import * as Yup from 'yup';
/* eslint-disable no-template-curly-in-string */

const mixed = {
  default: 'Este campo es inválido',
  required: 'Este campo es requerido',
  oneOf: 'Este campo debe ser uno de los siguientes valores: ${oneOf}',
  notOneOf: 'Este campo no debe ser uno de los siguientes valores: ${values}',
  defined: 'Este campo debe estar definido',
  min: 'El mínimo permitido es ${min} caracteres.',
  max: 'El máximo permitido es ${max} caracteres.',
};

const string = {
  length: 'Este campo debe tener ${length} caracteres.',
  min: 'El mínimo permitido es ${min} caracteres.',
  max: 'El máximo permitido es ${max} caracteres.',
  matches: '${path} must match the following: "${regex}"',
  email: 'Email no válido',
  url: 'Este campo debe ser url válido',
  trim: 'Este campo debe ser recortada',
  lowercase: 'Este campo debe estar en minúsculas',
  uppercase: 'Este campo debe estar en mayúsculas',
};

const number = {
  min: 'Este campo debe ser mayor o igual que ${min}.',
  max: 'Este campo debe ser menor o igual que ${max}.',
  lessThan: 'Este campo debe ser menor que ${less}.',
  moreThan: 'Este campo debe ser mayor que ${more}.',
  notEqual: 'Este campo no debe ser igual que ${notEqual}.',
  positive: 'Este campo debe ser un número positivo.',
  negative: 'Este campo debe ser un número negativo.',
  integer: 'Este campo debe ser un número entero.',
};

const date = {
  min: 'Este campo debe ser posterior a ${min}.',
  max: 'Este campo debe ser anterior a ${max}.',
  typeError: 'Este campo es inválido, intente nuevamente.',
};

const boolean = {};

const object = {
  noUnknown: 'Este campo tiene claves no especificadas: ${unknown}',
};

const array = {
  min: 'Este campo debe tener al menos ${min} items.',
  max: 'Este campo debe tener items iguales o inferiores a ${max}',
};

const localeSpa = {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
};

Yup.setLocale(localeSpa);

export default Yup;
